import React, { ReactNode } from 'react';
import { Container } from 'react-bootstrap';

interface SectionProps {
  children: ReactNode;
}

export const Section: React.FC<SectionProps> = (props: SectionProps) => {
  return (
    <Container>
      {props.children}
    </Container>
  );
};

export default Section;
